import { useCallback, useEffect } from 'react';
import {
    useDeleteSysMenuApi,
    useSaveSysMenuApi,
    useSearchSysMenuApi,
} from '../../../api/sys-menu-api';
import {
    useDeleteSysMenuGroupApi,
    useSaveSysMenuGroupApi,
    useSearchSysMenuGroupApi,
} from '../../../api/sys-menu-group-api';

export const useMenuService = () => {
    const sysMenuInit = useSearchSysMenuApi();
    const sysMenuGroupInit = useSearchSysMenuGroupApi();
    const sysMenuGroupSave = useSaveSysMenuGroupApi();
    const sysMenuGroupDelete = useDeleteSysMenuGroupApi();
    const sysMenuSave = useSaveSysMenuApi();
    const sysMenuDelete = useDeleteSysMenuApi();

    const {
        result: menus,
        error: menusError,
        initialized: initializedMenus,
        initializing: initializingMenus,
    } = sysMenuInit;

    const {
        result: menuGroups,
        initialized: initializedMenuGroups,
        initializing: initializingMenuGroups,
        error: menuGroupsError,
    } = sysMenuGroupInit;

    const loadSysMenus = useCallback(() => sysMenuInit.post(null, {}), [sysMenuInit]);

    const loadSysMenuGroups = useCallback(
        () => sysMenuGroupInit.post(null, {}, () => loadSysMenus()),
        [sysMenuGroupInit, loadSysMenus]
    );

    useEffect(() => {
        if (initializedMenuGroups || initializingMenuGroups || menuGroupsError) return;
        loadSysMenuGroups();
    }, [
        initializedMenuGroups,
        initializingMenuGroups,
        menuGroupsError,
        sysMenuGroupInit,
        loadSysMenuGroups,
    ]);

    const saveSysMenuGroup = (data: any, onSuccess: VoidFunction) =>
        sysMenuGroupSave.post(null, data, () => {
            onSuccess();
            loadSysMenuGroups();
        });

    const deleteSysMenuGroup = (id: string, onSuccess: VoidFunction) =>
        sysMenuGroupDelete.remove({ id: id }, () => {
            onSuccess();
            loadSysMenuGroups();
        });

    const saveSysMenu = (data: any, onSuccess: VoidFunction) =>
        sysMenuSave.post(null, data, () => {
            onSuccess();
            loadSysMenus();
        });

    const deleteSysMenu = (id: string, onSuccess: VoidFunction) =>
        sysMenuDelete.remove({ id: id }, () => {
            onSuccess();
            loadSysMenus();
        });

    return {
        groups: menuGroups?.sysMenuGroups,
        menus: menus?.sysMenus,
        error: menusError || menuGroupsError,
        initializedMenuGroups,
        initializingMenuGroups,
        initializedMenus,
        initializingMenus,

        loadSysMenus,
        loadSysMenuGroups,

        saveSysMenuGroup,
        saveSysMenu,

        deleteSysMenuGroup,
        deleteSysMenu,
    };
};
